import { Modal, Form, Input, Icon, Alert } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'
import { Constants } from '../../utils/constants'

const FormItem = Form.Item

function PaymentAccountComponent(props) {
  const { form, editingRecord, loading, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal
      centered
      title="Change the chatbot payment account"
      okText="Change"
      okButtonProps={{ loading: props.loading }}
      {...rest}>
      <Form layout="vertical">
        <FormItem label="New payment account">
          {getFieldDecorator('paymentAccount', {
            rules: [
              {
                required: true,
                message: 'Please provide a valid email or organization ID',
                pattern: Constants.EMAIL_ORGANIZATION_REGEX
              }
            ]
          })(<Input type="email" placeholder="example@example.com" addonAfter="@blip.ai" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}/>)}
        </FormItem>
      </Form>
      <Alert
        message="Careful!"
        description="This action will affect the cluster and throughput configurations!"
        type="warning"
        showIcon
      />
    </Modal>
  )
}

export const PaymentAccountModal = Form.create({
  mapPropsToFields: ({ record }) => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(PaymentAccountComponent))

PaymentAccountComponent.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  editingRecord: PropTypes.object,
  loading: PropTypes.bool,
}
